var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isButton
    ? _c(
        "button",
        {
          staticClass:
            "ob1-switch ob1-switch-button toggle toggle-rounded labels",
          class: { "ob1-switch-inverse": _vm.isInverse },
          attrs: {
            type: "button",
            role: "switch",
            "aria-checked": _vm.isChecked,
            disabled: _vm.disabled || _vm.readonly,
            "data-ob1-component": "Switch",
          },
          on: { click: _vm.onChange },
        },
        [
          _c("span", {
            staticClass: "on",
            attrs: { "aria-hidden": "true" },
            domProps: { textContent: _vm._s(_vm.onLabel) },
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "off",
            attrs: { "aria-hidden": "true" },
            domProps: { textContent: _vm._s(_vm.offLabel) },
          }),
        ]
      )
    : _c(
        "div",
        {
          staticClass: "ob1-switch",
          class: { "ob1-switch-inverse": _vm.isInverse },
        },
        [
          _c("input", {
            staticClass: "checkbox visually-hidden",
            attrs: {
              id: _vm.id,
              type: "checkbox",
              autocomplete: "off",
              disabled: _vm.disabled || _vm.readonly,
            },
            domProps: { checked: _vm.isChecked },
            on: { change: _vm.onChange },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "toggle toggle-rounded labels",
              attrs: { for: _vm.id },
            },
            [
              _c("span", {
                staticClass: "on",
                domProps: { textContent: _vm._s(_vm.onLabel) },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "off",
                domProps: { textContent: _vm._s(_vm.offLabel) },
              }),
            ]
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }